import { SKAN_UNIFIED_NAMESPACE } from '../../../../shared/constants';
import { UNIFIED_REPORT_DRILLDOWN } from '../../../../shared/constants/flipperFlags';
import { UnifiedAdsDrilldownMigrator } from '../../../../shared/services/UnifiedAdsDrilldownMigrator';
import type { ShareableData, SkanUnifiedSharableData } from '../types/shareableTypes';
import type { IShareableStateMigrator } from './ShareableStateMigratorService';

const flipperFlagProvider = {
  get: async () => window.App.context.flipper[UNIFIED_REPORT_DRILLDOWN],
};

export class ShareableUnifiedAdsMigratorService implements IShareableStateMigrator {
  static build() {
    return new ShareableUnifiedAdsMigratorService();
  }

  private drilldownMigrator: UnifiedAdsDrilldownMigrator<SkanUnifiedSharableData>;

  constructor() {
    this.drilldownMigrator = new UnifiedAdsDrilldownMigrator<SkanUnifiedSharableData>(flipperFlagProvider);
  }

  async migrate(state: ShareableData) {
    const skanUnified: SkanUnifiedSharableData = state[SKAN_UNIFIED_NAMESPACE];
    if (skanUnified) {
      await this.drilldownMigrator.migrate(skanUnified);
    }
  }
}
